{
  "name": "Course Atlas",
  "summary": "Hole {hole}. Par {par}, {length}. Stroke index {stroke_index}. {description}",
  "no_length": "length not set",
  "description": {
    "clear": "{shape}, with no bunkers, water or out of bounds.",
    "hazards": "{shape}. {hazards}."
  },
  "shape_line": "{shape}.",
  "shape": {
    "none": "A straight hole",
    "left": "A dogleg left",
    "right": "A dogleg right"
  },
  "hazard": {
    "fairway_bunker": "{count, plural, one {Fairway bunker} other {# fairway bunkers}}, {where}",
    "greenside_bunker": "{count, plural, one {Greenside bunker} other {# greenside bunkers}}, {where}",
    "waste": "{count, plural, one {Waste area} other {# waste areas}}, {where}",
    "water": "{kind}, {where}",
    "ob": "Out of bounds, {where}"
  },
  "water": {
    "pond": "Pond",
    "lake": "Lake",
    "river": "River",
    "burn": "Burn",
    "ditch": "Ditch",
    "sea": "The sea"
  },
  "where": {
    "left": "left",
    "right": "right",
    "middle": "in the middle",
    "front": "front of the green",
    "back": "back of the green",
    "front_left": "front left of the green",
    "front_right": "front right of the green",
    "back_left": "back left of the green",
    "back_right": "back right of the green",
    "green_left": "left of the green",
    "green_right": "right of the green",
    "crossing": "crossing the hole",
    "by_green": "beside the green",
    "behind_green": "behind the green"
  },
  "picture": {
    "to_come": "The picture of this hole is still being made. Its outline and its notes are here now.",
    "alt": "Hole {hole} from above, in the {time} light. {summary}",
    "high_contrast": "High-contrast picture",
    "high_contrast_hint": "Flat colours, a pattern on every surface and dark edges."
  },
  "title": "Course Atlas",
  "loading": "Loading the course…",
  "error": "We couldn't load this course. Check your connection and try again.",
  "retry": "Try again",
  "no_holes": "The holes of this course are not ready to show yet.",
  "offline": {
    "title": "You're offline",
    "map": "The world map needs a connection. Try again when you're back online.",
    "course": "This course needs a connection the first time you open it. Try again when you're back online.",
    "list": "The list of courses needs a connection the first time you open it. Try again when you're back online."
  },
  "style": {
    "links": "Links",
    "heathland": "Heathland",
    "parkland": "Parkland",
    "moorland": "Moorland",
    "clifftop": "Clifftop",
    "desert": "Desert",
    "mountain": "Mountain",
    "resort": "Resort"
  },
  "character": "A {style} course in {area}.",
  "par_length": "Par {par} · {length} from the {tee} tees",
  "flagship": "One of the game's flagship courses",
  "floodlit": "Floodlit range",
  "open": "Open",
  "open_again": "Open again",
  "closed": "Closed: {reason}",
  "holes_heading": "Holes",
  "hole_chip_label": "Hole {hole}, par {par}",
  "hole_row": "Par {par} · {length}",
  "bug": "Hole {hole} · Par {par} · {length} · Stroke index {stroke_index}",
  "lengths_heading": "Length from each tee",
  "length_row": "{tee}: {length}",
  "hazards_heading": "Hazards",
  "no_hazards": "No bunkers, water or out of bounds.",
  "pins_heading": "Pin positions",
  "pins_line": "The numbered dots are the course's four pin positions. Each day one of them is used, the same for everyone.",
  "picture_time": "Lit by the sun as at {time} at the course.",
  "picture_night": "It is night at the course now.",
  "credits": "Ground data: {attributions}",
  "zoom": {
    "in": "Zoom in",
    "out": "Zoom out",
    "reset": "Reset the zoom"
  },
  "yardage": "{length}",
  "list": {
    "intro": "Every course of the game. Open one to see each hole from above, with its hazards and its pin positions. It's free, and nothing is timed.",
    "row": "{style} · {holes, plural, one {# hole} other {# holes}} · Par {par} · {area}",
    "row_closed": "{style} · Closed · {area}",
    "empty": "No courses are open yet.",
    "error": "We couldn't load the courses. Check your connection and try again."
  },
  "credits_page": {
    "title": "Credits and licences",
    "intro": "Our courses are drawn from open map and ground data. These are the credits that data asks for, word for word.",
    "empty": "No course is open yet, so no data needs a credit.",
    "error": "We couldn't load the credits. Check your connection and try again.",
    "osm_link": "OpenStreetMap's copyright and licence page",
    "data_heading": "Map, places and weather",
    "data": {
      "natural_earth": "World map: Natural Earth (public domain)",
      "geonames": "Place names: GeoNames (CC BY 4.0)"
    }
  },
  "plan_trip": "Plan a trip here",
  "travel": {
    "title": "Travel",
    "loading": "Working out the journey",
    "error": "We could not work out this journey just now.",
    "retry": "Try again",
    "guest": "Make a golfer and save your progress to travel to other courses.",
    "to": "A trip to {course}",
    "home_to": "The way home to {course}",
    "journey_heading": "The journey",
    "label": {
      "distance": "How far",
      "cost": "Cost",
      "hours": "Golf hours",
      "jet_lag": "Jet lag",
      "fee": "Green fee",
      "visitors": "Visitors"
    },
    "distance": "{km} km",
    "free": "Free, as it is under 40 km",
    "waived": "Free, as the course is closed",
    "coins": "{coins, plural, one {# Coin} other {# Coins}}",
    "junior_fare": "{coins, plural, one {# Coin} other {# Coins}}: the junior fare (the full fare is {adult})",
    "hours": "{hours, plural, one {# hour} other {# hours}} of that day",
    "half_hour": "Half an hour of that day",
    "none": "None",
    "jet_lag_one": "1 day: energy {first} on the day of arrival",
    "jet_lag_two": "2 days: energy {first} on the day of arrival, then {second}",
    "fee": "{coins, plural, one {# Coin} other {# Coins}}, paid when a round there is booked",
    "home_course": "None: this is your home course",
    "rules_none": "Welcome on any day",
    "course_heading": "Playing at {course}",
    "rule": {
      "max_handicap": "An FL Handicap of {value} or lower",
      "days": "{value} only",
      "lead_days": "Book at least {value, plural, one {# day} other {# days}} ahead",
      "member_guest_only": "Only as a member's guest"
    },
    "day": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "refusal": {
      "handicap": "Your golfer cannot book a round here yet: the club asks for a handicap your golfer does not have yet.",
      "day": "Your golfer cannot play here tomorrow. It is not a day for visitors.",
      "lead_time": "Your golfer cannot play here tomorrow: the club asks you to book further ahead.",
      "member_guest_only": "Your golfer can play here only as a member's guest."
    },
    "wallet": "You have {coins, plural, one {# Coin} other {# Coins}}.",
    "go": "Travel there for {coins, plural, one {# Coin} other {# Coins}}",
    "go_free": "Travel there",
    "go_home": "Go home for {coins, plural, one {# Coin} other {# Coins}}",
    "go_home_free": "Go home",
    "done": "Your golfer is now at {course}.",
    "problem": {
      "not_enough_coins": "You do not have enough Coins for this trip.",
      "course_closed": "This course is closed just now, so nobody can travel there.",
      "no_home_club": "Your golfer needs a home club before travelling.",
      "no_such_course": "This course cannot be found. It may have closed for good.",
      "other": "The trip did not go through. Nothing was spent. Please try again."
    },
    "already_here": "Your golfer is at this course already.",
    "refused_heading": "This trip is not open"
  },
  "passport": {
    "title": "Passport",
    "intro": "Every course your golfer plays gets a stamp. When every course on a list is stamped, the list pays its Coins once. Nothing is timed.",
    "summary": "Courses stamped",
    "lists_heading": "Course lists",
    "stamps_heading": "Stamps",
    "list": {
      "style_nation": "{style} courses in {nation}",
      "flagship_four": "The Flagship Four",
      "home_nations": "Home Nations",
      "across_the_pond": "Across the Pond",
      "other": "A list of courses"
    },
    "rule": {
      "match": "Play every course on the list.",
      "flagship": "Play each of the game's flagship courses.",
      "one_each": "Play a course in each of {values}."
    },
    "progress": "Played",
    "reward": "Pays",
    "completed": "Complete. Paid on {date}",
    "stamp_line": "{style} · {place}",
    "best": "Best {gross}",
    "no_best": "No score",
    "flagship": "Flagship",
    "open_course": "Open {name} in the Course Atlas",
    "empty": "No stamps yet. Play a round at any course and its stamp appears here.",
    "no_lists": "No course lists yet.",
    "guest": "Make a golfer and save your progress to start a passport.",
    "error": "We couldn't load your passport. Check your connection and try again.",
    "hub": {
      "uki": "Britain and Ireland",
      "usa": "the United States"
    },
    "and": "{first} and {last}",
    "of": "{done} of {total}",
    "first_played": "First played {date}",
    "best_label": "Best",
    "reward_paid": "Paid"
  },
  "map": {
    "title": "World map",
    "intro": "Every course of the game on one map. Tap a course to open it. Nothing here is timed.",
    "search_label": "Find a course",
    "search_hint": "A course, a county or a town",
    "search_go": "Find",
    "search_clear": "Clear",
    "results_name": "{count, plural, one {# course} other {# courses}} with that name",
    "results_area": "{count, plural, one {# course} other {# courses}} there",
    "results_place": "Nearest to {place}",
    "result_km": "{km} km away",
    "results_none": "We couldn't find that. Try the nearest town.",
    "legend_heading": "What the pins mean",
    "legend": {
      "home": "Your home club",
      "owned": "A club you own",
      "linked": "Your real club's course",
      "flagship": "A flagship course",
      "visited": "A course you've played",
      "unvisited": "A course you haven't played yet",
      "closed": "Closed for now",
      "floodlit": "Lit after dark"
    },
    "weather_heading": "Weather now",
    "weather": {
      "clear": "Clear",
      "cloud": "Cloudy",
      "rain": "Rain",
      "snow": "Snow",
      "storm": "Storms"
    },
    "list_heading": "All courses",
    "row": "{kind} · {area}",
    "row_closed": "Closed · {area}",
    "row_floodlit": "Lit after dark",
    "map_label": "Map of the game's courses. The list below has every course on it.",
    "map_native": "The map opens on the web for now. Every course is in the list below.",
    "zoom_in": "Zoom in",
    "zoom_out": "Zoom out",
    "hub_uki": "UK and Ireland",
    "hub_usa": "USA",
    "empty": "No courses are open yet.",
    "error": "We couldn't load the map. Check your connection and try again.",
    "credit": "Map: Natural Earth. Places: GeoNames (CC BY 4.0).",
    "weather_credit": {
      "climatology": "Contains modified Copernicus Climate Change Service information. ERA5, ECMWF. CC BY 4.0.",
      "open_meteo": "Weather data by Open-Meteo.com",
      "met_office": "Contains Met Office data © Crown copyright",
      "nws": "Weather data: US National Weather Service (NOAA)",
      "openweather": "Weather data provided by OpenWeather"
    }
  }
}
